const apiUrl = process.env.REACT_APP_API_URL;
export const PostPassarLlistaFiltratPdf = async (json: any, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/inscripcions/passarllista/filtrat/pdf`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
